import React, { useState, useEffect } from 'react';
import { Form, Icon, Input, Button, Row, Col, notification, Modal as ModalAntd } from 'antd';
import { updateUserInfoApi } from '../../../../api/user';
import { getAccesTokenApi } from '../../../../api/auth';

import './EditUserPassForm.scss';

const { success } = ModalAntd;

export default function EditUserForm(props) {
	const { user, setUser, setIsVisibleModal } = props;
	const [userData, setUserData] = useState({});

	useEffect(() => {
		setUserData({
			nombre: user.nombre,
			apellido: user.apellido,
			email: user.email,
			id_rol: user.id_rol,
			avatar: user.avatar,
			password: '',
			repeatPassword: '',
			login: 1,
		});
	}, [user]);

	const updateUser = (e) => {
		e.preventDefault();
		const token = getAccesTokenApi();
		let userUpdate = userData;

		if (userUpdate.password === '') {
			delete userUpdate.password;
		}
		if (userUpdate.repeatPassword === '') {
			delete userUpdate.repeatPassword;
		}

		if (!userUpdate.password || !userUpdate.password) {
			notification['error']({
				message: 'Debe ingresar la nueva contraseña',
			});
			return;
		}

		if (userUpdate.password || userUpdate.repeatPassword) {
			if (userUpdate.password !== userUpdate.repeatPassword) {
				notification['error']({
					message: 'Contraseñas NO coinciden',
				});
				return;
			} else {
				delete userUpdate.repeatPassword;
			}
		}

		updateUserInfoApi(token, userUpdate, user.id_usuario).then((result) => {
			if (result.estado === 'OK') {
				setUser(userData);
				setUserData({});
				setIsVisibleModal(false);
				success({
					title: 'Contraseña Actualizada',
					content: `Su contraseña fue actualizada satisfactoriamente`,
					onOk() {
						window.location.reload();
					},
				});
			} else {
				notification['error']({
					//message: result.resultado,
					message: 'Error actualizando Contraseña',
				});
			}
		});
	};

	return (
		<div className="edit-user-form">
			<EditForm setUserData={setUserData} userData={userData} updateUser={updateUser} />
		</div>
	);
}

function EditForm(props) {
	const { userData, setUserData, updateUser } = props;

	return (
		<Form className="form-edit" onSubmit={updateUser}>
			<Row gutter={24}>
				<Col span={12}>
					<Form.Item>
						<Input
							prefix={<Icon type="lock" />}
							value={userData.password}
							type="password"
							placeholder="Contraseña"
							onChange={(e) => setUserData({ ...userData, password: e.target.value })}
						/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item>
						<Input
							prefix={<Icon type="lock" />}
							type="password"
							value={userData.repeatPassword}
							placeholder="Repetir contraseña"
							onChange={(e) => setUserData({ ...userData, repeatPassword: e.target.value })}
						/>
					</Form.Item>
				</Col>
			</Row>
			<Form.Item>
				<Button type="primary" htmlType="submit" className="btn-submit">
					Cambiar Contraseña
				</Button>
			</Form.Item>
		</Form>
	);
}
